var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCvc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 124.63 124.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f3ba2f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.32,124.63C27.96,124.63,0,96.68,0,62.32S27.96,0,62.32,0s62.32,27.96,62.32,62.32-27.96,62.32-62.32,62.32ZM62.32,6.45C31.51,6.45,6.45,31.51,6.45,62.32s25.06,55.87,55.87,55.87,55.87-25.06,55.87-55.87S93.12,6.45,62.32,6.45Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.44,37.09c-4.97,1.22-9.29,3.54-12.93,6.97-3.65,3.42-6.12,7.55-7.42,12.38-1.3,4.83-1.23,9.63.2,14.39,1.44,4.77,4,8.94,7.68,12.52,3.68,3.58,8.08,6.06,13.21,7.45,4.48,1.21,9.01,1.39,13.59.54,4.58-.85,8.65-2.63,12.22-5.36l-7.35-9.59c-2.08,1.58-4.48,2.61-7.2,3.1-2.72.49-5.43.38-8.12-.35-2.99-.81-5.58-2.24-7.77-4.3-2.2-2.06-3.73-4.44-4.61-7.13-.88-2.69-.95-5.41-.21-8.15.74-2.74,2.17-5.06,4.28-6.97,2.12-1.91,4.63-3.2,7.53-3.86,2.9-.66,5.87-.58,8.91.24,2.69.72,5.08,1.98,7.19,3.78,2.1,1.8,3.66,3.9,4.67,6.3l11.17-4.6c-1.71-4.15-4.34-7.74-7.87-10.77-3.53-3.04-7.54-5.16-12.02-6.36-5.13-1.38-10.18-1.46-15.15-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.34,96.5l6.54,1.76,2.59-9.61c-2.15-1.06-4.14-2.36-5.96-3.91l-3.17,11.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.59,36.31l3.13-11.62-6.54-1.76-3.71,13.74c2.35-.41,4.72-.53,7.11-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.53,28.14l-6.54-1.76-2.99,11.07c2.22.63,4.33,1.49,6.32,2.58l3.21-11.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.15,99.95l6.54,1.76,2.66-9.87c-2.27-.06-4.52-.37-6.76-.95l-2.44,9.05Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvc);
export default __webpack_public_path__ + "static/media/cvc.600e1846f910a2982395a5b2d7e29486.svg";
export { ForwardRef as ReactComponent };